import { WithdrawalFormName } from "@/features/withdrawal/components/WithdrawalForm/types";
import { Currency } from "@/types/currency";

export const withdrawalFormLabelMap: Record<WithdrawalFormName, string> = {
  [WithdrawalFormName.Amount]: "Amount",
  [WithdrawalFormName.Currency]: "Currency",
};

export const currencies = Object.values(Currency);
